module.exports = __webpack_public_path__ + "static/index/img/baikal-207.ec6c79b6.jpg";